export enum TRANSACTION_TYPE {
  VA_TOP_UP = 'VA_TOP_UP',
  PAYMENT = 'PAYMENT',
  VA_PAYMENT = 'VA_PAYMENT',
  QRIS_PAYMENT = 'QRIS_PAYMENT',
  CARD_PAYMENT = 'CARD_PAYMENT',
  WALLET_PAYMENT = 'WALLET_PAYMENT',
  REFUND = 'REFUND',
  REFUND_FEE = 'REFUND_FEE',
  FEE_REFUND = 'FEE_REFUND',
  DISBURSEMENT = 'DISBURSEMENT',
  BULK_DISBURSEMENT = 'BULK_DISBURSEMENT',
  WITHDRAWAL = 'WITHDRAWAL',
  DISBURSEMENT_WITHDRAWAL = 'DISBURSEMENT_WITHDRAWAL',
  PAYMENT_WITHDRAWAL = 'PAYMENT_WITHDRAWAL',
  VIRTUAL_TERMINAL_WITHDRAWAL = 'VIRTUAL_TERMINAL_WITHDRAWAL',
  WALLET_WITHDRAWAL = 'WALLET_WITHDRAWAL',
  PAYMENT_FEE = 'PAYMENT_FEE',
  DISBURSEMENT_FEE = 'DISBURSEMENT_FEE',
  ACCOUNT_INQUIRY_FEE = 'ACCOUNT_INQUIRY_FEE',
  XB_FEE = 'XB_FEE',
  PLATFORM_ACTIVITY_FEE = 'PLATFORM_ACTIVITY_FEE',
  PLATFORM_TRANSFER_FEE = 'PLATFORM_TRANSFER_FEE',
  PLATFORM_TRANSACTION_FEE = 'PLATFORM_TRANSACTION_FEE',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
  MANUAL_TOP_UP = 'MANUAL_TOP_UP',
  BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT',
  BULK = 'BULK',
  SINGLE = 'SINGLE',
  TRANSFER = 'TRANSFER',
  TRANSFER_IN = 'TRANSFER_IN',
  TRANSFER_OUT = 'TRANSFER_OUT',

  BANK_TRANSFER = 'BANK_TRANSFER',
  CASHBACK = 'CASHBACK',
  MERCHANT_TOP_UP = 'MERCHANT_TOP_UP',
  CUSTOMER_TOP_UP = 'CUSTOMER_TOP_UP',
  MERCHANT_PAYMENT = 'MERCHANT_PAYMENT',
  FEE_BANK_TRANSFER = 'FEE_BANK_TRANSFER',
  FEE_MERCHANT_PAYMENT = 'FEE_MERCHANT_PAYMENT',
  FEE_TRANSFER = 'FEE_TRANSFER',
  FEE_BILL = 'FEE_BILL',
  FEE_TOP_UP = 'FEE_TOP_UP',
  FEE_WALLET_TRANSACTION = 'FEE_WALLET_TRANSACTION',
  INTERNATIONAL_PAYOUT = 'INTERNATIONAL_PAYOUT',
}
// DISBURSEMENT, PAYMENT, FEE, MANUAL_ADJUSTMENT;

export const TRANSACTION_TYPE_LABEL: Record<string, string> = {
  [TRANSACTION_TYPE.VA_TOP_UP]: 'VA Top Up',
  [TRANSACTION_TYPE.VA_PAYMENT]: 'VA Payment',
  [TRANSACTION_TYPE.QRIS_PAYMENT]: 'QRIS Payment',
  [TRANSACTION_TYPE.WALLET_PAYMENT]: 'Ewallet Payment',
  [TRANSACTION_TYPE.CARD_PAYMENT]: 'Cards Payment',
  [TRANSACTION_TYPE.REFUND]: 'Payment Refund',
  [TRANSACTION_TYPE.REFUND_FEE]: 'Refund Fee',
  [TRANSACTION_TYPE.FEE_REFUND]: 'Refund Payment Fee',
  [TRANSACTION_TYPE.DISBURSEMENT]: 'Single Payout',
  [TRANSACTION_TYPE.BULK_DISBURSEMENT]: 'Bulk Payout',
  [TRANSACTION_TYPE.INTERNATIONAL_PAYOUT]: 'International Payout',
  [TRANSACTION_TYPE.DISBURSEMENT_WITHDRAWAL]: 'Withdrawal: Payout',
  [TRANSACTION_TYPE.PAYMENT_WITHDRAWAL]: 'Withdrawal: Payment',
  [TRANSACTION_TYPE.VIRTUAL_TERMINAL_WITHDRAWAL]: 'Withdrawal: Virtual Terminal',
  [TRANSACTION_TYPE.WALLET_WITHDRAWAL]: 'Withdrawal: Wallet',
  [TRANSACTION_TYPE.ACCOUNT_INQUIRY_FEE]: 'Account Inquiry Fee',
  [TRANSACTION_TYPE.XB_FEE]: 'Cross Border Fee',
  [TRANSACTION_TYPE.PLATFORM_ACTIVITY_FEE]: 'Platform Activity Fee',
  [TRANSACTION_TYPE.PLATFORM_TRANSFER_FEE]: 'Platform Transfer Fee',
  [TRANSACTION_TYPE.PLATFORM_TRANSACTION_FEE]: 'Platform Transaction Fee',
  [TRANSACTION_TYPE.MANUAL_TOP_UP]: 'Manual Top Up',
  [TRANSACTION_TYPE.BALANCE_ADJUSTMENT]: 'Balance Adjustment',
  [TRANSACTION_TYPE.TRANSFER]: 'Balance Transfer',
  [TRANSACTION_TYPE.TRANSFER_IN]: 'Transfer In',
  [TRANSACTION_TYPE.TRANSFER_OUT]: 'Transfer Out',

  [TRANSACTION_TYPE.BANK_TRANSFER]: 'Bank Transfer',
  [TRANSACTION_TYPE.CASHBACK]: 'Cashback',
  [TRANSACTION_TYPE.MERCHANT_TOP_UP]: 'Merchant Top Up',
  [TRANSACTION_TYPE.MERCHANT_PAYMENT]: 'Merchant Payment',
  [TRANSACTION_TYPE.CUSTOMER_TOP_UP]: 'Customer Top Up',

  [TRANSACTION_TYPE.PAYMENT_FEE]: 'Payment Fee',
  [TRANSACTION_TYPE.DISBURSEMENT_FEE]: 'Payout Fee',
  [TRANSACTION_TYPE.FEE_BANK_TRANSFER]: 'Bank Transfer Fee',
  [TRANSACTION_TYPE.FEE_MERCHANT_PAYMENT]: 'Merchant Payment Fee',
  [TRANSACTION_TYPE.FEE_TRANSFER]: 'Peer Transfer Fee',
  [TRANSACTION_TYPE.FEE_BILL]: 'PPOB Fee',
  [TRANSACTION_TYPE.FEE_TOP_UP]: 'Top Up Fee',
  [TRANSACTION_TYPE.FEE_WALLET_TRANSACTION]: 'Wallet Transaction Fee',
};

export enum TRANSACTION_STATUS {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum TRANSACTION_CHANNEL {
  MANUAL_TRANSFER = 'MANUAL_TRANSFER',
  BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT',
}

export enum TRANSACTION_BALLANCE_TYPE {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export enum APPROVAL_STATUS {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  WAITING = 'WAITING',
}

export const excludedTransactionTypesFilters = [
  TRANSACTION_TYPE.TRANSFER_IN,
  TRANSACTION_TYPE.TRANSFER_OUT,
  TRANSACTION_TYPE.FEE_TRANSFER,
  TRANSACTION_TYPE.BANK_TRANSFER,
  TRANSACTION_TYPE.XB_FEE,
  TRANSACTION_TYPE.FEE_REFUND,
  TRANSACTION_TYPE.PLATFORM_TRANSFER_FEE,
];
